export const designersKeys = {
  all: ["designers"],
  lists: () => [...designersKeys.all, "list"],
  list: (params) => [...designersKeys.lists(), params ?? {}],
  details: () => [...designersKeys.all, "detail"],
  detail: (documentId) => [...designersKeys.details(), documentId],
};
